import { jsx as _jsx } from "react/jsx-runtime";
import { documentToReactComponents, } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
import { Link } from '@servicetitan/design-system';
export const richTextRenderOptions = {
    openHyperlinkInNewTab: {
        [INLINES.HYPERLINK]: (node, children) => {
            return (_jsx(Link, Object.assign({ primary: true, href: node.data.uri, target: "_blank", rel: "noopener noreferrer" }, { children: children })));
        },
    },
};
export const documentToReactComponent = ({ document, options, renderNodes, }) => {
    const renderOptions = Object.assign(Object.assign({}, options), { renderNode: renderNodes === null || renderNodes === void 0 ? void 0 : renderNodes.reduce((acc, x) => (Object.assign(Object.assign({}, acc), x))) });
    return document ? documentToReactComponents(document, renderOptions) : undefined;
};
//# sourceMappingURL=document-to-react-component.js.map